.backdrop {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-scrim);
  padding: var(--spacing-16);
  z-index: var(--z-modal);
}

.dialog {
  width: 100%;
  max-width: 420px;
  max-height: 90vh;
  overflow-y: auto;
  background: var(--bg-primary);
  border: 1px solid var(--stroke-neutral);
  border-radius: var(--radius-12);
  box-shadow: var(--shadow-dialog);
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-16);
  border-bottom: 1px solid var(--stroke-neutral);
}

.body,
.successBody {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-12);
  padding: var(--spacing-16);
}

/* 6px literal: no --spacing-6 token in the Figma scale; tightest readable field label↔control gap (between --spacing-4 and --spacing-8), matches SettingsPanel. */
.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* 10px literal: same scale gap — no --spacing-10 token exists. */
.textarea {
  width: 100%;
  resize: vertical;
  min-height: 96px;
  padding: 10px;
  font: inherit;
  color: var(--text-primary);
  background: var(--bg-primary);
  border: 1px solid var(--stroke-neutral);
  border-radius: var(--radius-8);
}

.textarea:focus {
  outline: none;
  border-color: var(--brand);
  /* Match the brand focus halo Input applies on :focus-within. */
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--brand) 18%, transparent);
}

.disclosure {
  margin: 0;
}

.honeypot {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
